/**
 * Последние матчи организации — лента на главной.
 *
 * `previousMatches` — готовый запрос бэкенда (прошедшие матчи, новые первыми), `tournamentId` — это
 * **организация** (см. глоссарий), а не соревнование. Новых запросов и правок бэкенда не требуется.
 */
export interface LatestMatchTeamDto {
  score: number | null;
  teamOrder: number | null;
  team: { id: number; name: string; emblem: { externalUrl: string } | null } | null;
}

export interface LatestMatchDto {
  id: number;
  date: string | null;
  championship: { id: number; name: string } | null;
  round: { id: number; stage: { id: number } | null } | null;
  teamMatches: LatestMatchTeamDto[] | null;
}

export const LATEST_MATCHES_QUERY = `
  query LatestMatches($tournamentId: Int!, $limit: Int!) {
    previousMatches(tournamentId: $tournamentId, limit: $limit) {
      id
      date
      championship {
        id
        name
      }
      round {
        id
        stage {
          id
        }
      }
      teamMatches {
        score
        teamOrder
        team {
          id
          name
          emblem {
            externalUrl
          }
        }
      }
    }
  }
`;
